import useLocale from 'next-translate/useTranslation';
import React from 'react';
import {
  SiCanva,
  SiGithub,
  SiGmail,
  SiGooglecalendar,
  SiGoogledrive,
  SiNotion,
} from 'react-icons/si';

const CONNECTORS: Array<{
  name: string;
  Icon: React.ComponentType<{ className?: string }>;
  colorClass: string;
}> = [
  { name: 'Gmail', Icon: SiGmail, colorClass: 'text-[#EA4335]' },
  {
    name: 'Google Calendar',
    Icon: SiGooglecalendar,
    colorClass: 'text-[#4285F4]',
  },
  { name: 'Google Drive', Icon: SiGoogledrive, colorClass: 'text-[#34A853]' },
  {
    name: 'Notion',
    Icon: SiNotion,
    colorClass: 'text-slate-900 dark:text-white',
  },
  { name: 'Canva', Icon: SiCanva, colorClass: 'text-[#00C4CC]' },
  {
    name: 'GitHub',
    Icon: SiGithub,
    colorClass: 'text-slate-900 dark:text-white',
  },
];

const MarkyConnectors = () => {
  const { t } = useLocale('marky');

  return (
    <section className='relative border-y border-slate-200 bg-slate-50 py-16 dark:border-white/[0.06] dark:bg-slate-900 lg:py-20'>
      <div className='mx-auto max-w-5xl px-4 text-center sm:px-6'>
        <h2 className='text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white md:text-4xl'>
          {t('Plugged into your world')}
        </h2>
        <p className='mx-auto mt-4 max-w-2xl text-lg text-slate-600 dark:text-slate-400'>
          {t(
            'Marky reads your inbox, books your calendar, files your docs and ships your code — with your permission, in your accounts.',
          )}
        </p>

        <div className='mt-10 flex flex-wrap justify-center gap-3'>
          {CONNECTORS.map((connector) => (
            <span
              key={connector.name}
              className='inline-flex items-center gap-2.5 rounded-full border border-slate-200 bg-white px-5 py-2.5 font-semibold text-slate-800 shadow-sm dark:border-white/10 dark:bg-white/[0.04] dark:text-slate-200'
            >
              <connector.Icon
                className={`h-5 w-5 ${connector.colorClass}`}
                aria-hidden='true'
              />
              {connector.name}
            </span>
          ))}
          <span className='inline-flex items-center gap-2.5 rounded-full border border-dashed border-slate-300 px-5 py-2.5 font-semibold text-slate-500 dark:border-white/20 dark:text-slate-400'>
            {t('+ your own APIs & MCP servers')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default MarkyConnectors;
